(function () {
    'use strict';

    angular.module('Services').factory('RoutingMatrixService', RoutingMatrixService);

    RoutingMatrixService.$inject = [
        'Request'
    ];

    function RoutingMatrixService(
        Request
    ) {
        return {
            routes: {
                getAll: (successCallback, errorCallback, data) => {
                    Request.get({
                        url: ApiURLs.routingMatrix.getAll,
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: data
                    });
                },
                get: (successCallback, errorCallback, id) => {
                    // todo: add implementation code here...
                    Request.get({
                        url: ApiURLs.routingMatrix.get,
                        successCallback: successCallback, 
                        errorCallback: errorCallback
                    });
                },
                create: (successCallback, errorCallback, data) => {
                    Request.get({
                        url: ApiURLs.routingMatrix.create,
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: data
                    });
                },
                update: (successCallback, errorCallback, data) => {
                    Request.get({
                        url: ApiURLs.routingMatrix.update,
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: data
                    });
                },
                payloadMapper: (data) => {
                    // todo: map data here for API consumption
                    return data;
                },
                delete: (successCallback, errorCallback, id) => {
                    Request.get({
                        url: ApiURLs.routingMatrix.delete,
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                    })
                }
            },
            zones: {
                getAll: (successCallback, errorCallback, data) => {
                    Request.get({
                        url: ApiURLs.routingMatrix.zones,
                        successCallback: successCallback, 
                        errorCallback: errorCallback,
                        data: data
                    });
                }
            },
            locations: {
                getAll: (successCallback, errorCallback) => {
                    Request.get({
                        url: ApiURLs.office.availableOffices,
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    })
                }
            }
        };
    }
})();


// WEBPACK FOOTER //
// ./js/services/RoutingMatrixService.js